import type { TFunction } from 'i18next';

import { MINUTE_MS, relativeTime } from '../../utils/format';

const elapsedSince = (at: string, now: number): number | null => {
  const fired = Date.parse(at);
  return Number.isNaN(fired) ? null : now - fired;
};

export const whenText = (t: TFunction, at: string, now: number): string => {
  const elapsed = elapsedSince(at, now);
  if (elapsed === null) return '';
  if (elapsed < MINUTE_MS) return t('closeTheLoop.inApp.now', 'Just now');
  return relativeTime(at, now);
};

export const sourceText = (t: TFunction, at: string, now: number): string => {
  const elapsed = elapsedSince(at, now);
  if (elapsed === null) return t('closeTheLoop.inApp.sourceApp', 'DigitalPaani');
  if (elapsed < MINUTE_MS) return t('closeTheLoop.inApp.sourceNow', 'DigitalPaani · now');
  return t('closeTheLoop.inApp.source', 'DigitalPaani · {{when}}', { when: relativeTime(at, now) });
};

export const firedWhen = (t: TFunction, at: string, now: number): string => {
  const elapsed = elapsedSince(at, now);
  if (elapsed === null) return '';
  if (elapsed < MINUTE_MS) return t('closeTheLoop.inApp.justNow', 'just now');
  return relativeTime(at, now);
};
